import type { Gutter } from 'antd/lib/grid/row';

export const GRID_SPACING_DEFAULT = [16, 16] as Gutter;
export const ORIGINAL_STATUS_COMPLETED = 'completed';
export const ORIGINAL_STATUS_IN_PROGRESS = 'in_progress';
export const ORIGINAL_STATUS_PENDING = 'pending';
